import { render, staticRenderFns } from "./LandingStock.html?vue&type=template&id=77116ff6&scoped=true&"
import script from "./LandingStock.ts?vue&type=script&lang=ts&"
export * from "./LandingStock.ts?vue&type=script&lang=ts&"
import style0 from "./LandingStock.scss?vue&type=style&index=0&id=77116ff6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77116ff6",
  null
  
)

export default component.exports